import { VaultDetails } from "../store/vaults";
import { VaultData } from "../queries/vault";
import { BigNumber } from "ethers";
import { constructVaultDetails } from "./constructVaultDetails";

export const fetchVaultDetails = async (
  chainId: number,
  vault: VaultData,
  fetchPrice: (address: string) => Promise<number>,
  fetchReward: (
    vaultAddress: string
  ) => Promise<{ reward: BigNumber; timestamp: number }>,
  fetchRewardPrice: (vaultAddress: string) => Promise<number>
): Promise<VaultDetails | undefined> => {
  const start = Date.now()
  console.log(`fetching vault details START at (${start.toString()}) (${vault.id})...`)
  const t0Price = await fetchPrice(vault.token0.address);
  const t1Price = await fetchPrice(vault.token1.address);
  const { reward, timestamp } = await fetchReward(vault.address);
  const rewardTokenPrice = await fetchRewardPrice(vault.address);
  console.log(
    `fetching vault details COMPLETE (${vault.address}) (${vault.token0.symbol}/${vault.token1.symbol}) at (${Date.now().toString()}).}`
  )
  console.log(`Took ${((Date.now() - start) / 1000).toLocaleString('en-US')}}`)
  const vaultDetails: VaultDetails = constructVaultDetails(vault);

  return {
    ...vaultDetails,
    tokenPrice0: t0Price,
    tokenPrice1: t1Price,
    reward,
    rewardTokenPrice,
    rewardTimestamp: timestamp,
  };
}